import { Pagination as PaginationBar } from 'antd';
import { useTranslation } from 'react-i18next';
import { ApplicationSummaryCard } from './ApplicationSummaryCard';
import {
	ApplicationSummary,
	ApplicationSummaryList,
	PagingConfig,
} from '../../../shared/VolunteerApplicationServiceTypes';
import { DEFAULT_PAGE_SIZE } from '../../../shared/Constants';
import isEmpty from 'lodash/isEmpty';
import { ApplicationSummaryTableView } from './ApplicationSummaryTableView';
import EmptyList from '../../../components/EmptyList';

export const ApplicationsList = ({
	data: { applicationSummary: applications, pagination },
	onPageChange,
	onEvaluateClick,
	onVerifyResultsClick,
	pageConfig,
}: {
	data: ApplicationSummaryList;
	onPageChange: (page: number, pageSize: number) => void;
	onEvaluateClick: (application: ApplicationSummary) => void;
	onVerifyResultsClick: (application: ApplicationSummary) => void;
	pageConfig: PagingConfig;
}) => {
	const { t } = useTranslation();
	if (
		isEmpty(pagination.totalNoOfRecords) ||
		pagination.totalNoOfRecords === 0
	) {
		return <EmptyList message={t('noApplications')} />;
	}

	const applicationCards = applications?.map((application) => (
		<div className="mb-[16px]" key={application.applicationId}>
			<ApplicationSummaryCard
				{...application}
				onEvaluateClick={onEvaluateClick}
				onVerifyResultsClick={onVerifyResultsClick}
			/>{' '}
		</div>
	));

	return (
		<div className="flex flex-col gap-6">
			<div className="sm:hidden">
				{applicationCards}
				<div className="flex justify-center w-full">
					<PaginationBar
						current={pageConfig.pageNo ?? 1}
						total={pagination.totalNoOfRecords}
						defaultPageSize={pageConfig.pageSize ?? DEFAULT_PAGE_SIZE}
						onChange={onPageChange}
					/>
				</div>
			</div>
			<div className="hidden sm:block">
				<ApplicationSummaryTableView
					applications={applications}
					onEvaluateClick={onEvaluateClick}
					onVerifyResultsClick={onVerifyResultsClick}
					pagination={pagination}
					onPageChange={onPageChange}
					pageConfig={pageConfig}
				/>
			</div>
		</div>
	);
};
